export { PersonalizedContainer } from './Personalized'
export { ItemToItemContainer } from './ItemToItem'
export { default as recomendationReducer } from './reducer'



// WEBPACK FOOTER //
// ./src/features/Recomendation/index.js